import { render, staticRenderFns } from "./AddReseller.vue?vue&type=template&id=2736ce15&"
import script from "./AddReseller.vue?vue&type=script&lang=js&"
export * from "./AddReseller.vue?vue&type=script&lang=js&"
import style0 from "./AddReseller.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports